<mydocma-app-container [options]="options" class="mydocma">

</mydocma-app-container>


<mydocma-image-viewer
    [viewerService]="imageViewerService"
    *ngIf="imageViewerService && imageViewerService.fullScreen$ | async">
</mydocma-image-viewer>
